import { render, staticRenderFns } from "./EmployeeRequests.vue?vue&type=template&id=6b49b949&"
import script from "./EmployeeRequests.vue?vue&type=script&lang=js&"
export * from "./EmployeeRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports